// libs
import { styled } from '@nykaa/ui-components';

// constants
import { DWEB_MAX_WIDTH } from 'shared/styles/base';

// styles
export const Container = styled.div`
  max-width: ${DWEB_MAX_WIDTH}px;
  margin: ${({ theme }) => `${theme.spacing.spacing100} auto ${theme.spacing.spacing320}`};
  padding: 0;
  position: relative;
  display: flex;
  justify-content: flex-start;
`;

export const Images = styled.section`
  display: flex;
  width: 58.33%;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing80}`};
`;

export const Thumbnails = styled.ul`
  width: 99px;
  margin-right: ${({ theme }) => theme.spacing.spacing160};
  display: flex;
  flex-flow: column;
  list-style: none;
  padding: 0;
  overflow: hidden;
`;

export const Thumbs = styled.li`
  width: 99px;
  height: 132px;
  flex: 0 0 auto;
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
  background: ${({ theme }) => theme.colors.shimmerBg};
`;

export const MainImage = styled.div`
  width: 503px;
  height: 670.66px;
  background: ${({ theme }) => theme.colors.shimmerBg};
`;

export const Details = styled.section`
  display: flex;
  flex-flow: column;
  flex: 1;
  min-width: 0;
  min-height: 670.66px;
  padding: ${({ theme }) => `0 0 ${theme.spacing.spacing120}`};
`;

export const Line = styled.div`
  display: block;
  height: 13px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing50};
  background: ${({ theme }) => theme.colors.shimmerBg};
`;

export const Title = styled(Line)`
  width: 40px;
`;

export const SubTitle = styled(Line)`
  width: 200px;
`;

export const Price = styled(Line)`
  margin-top: ${({ theme }) => theme.spacing.spacing50};
  width: 80px;
`;

export const ColorSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing160};
`;

export const ColorTitle = styled(Line)`
  width: 120px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
`;

export const ColorValue = styled(Line)`
  width: 80px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
`;

export const ColorOptions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing80};
`;

export const ColorOption = styled.div`
  width: 80px;
  height: 104px;
  background: ${({ theme }) => theme.colors.shimmerBg};
`;

export const SizeSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing160};
`;

export const SizeTitle = styled(Line)`
  width: 110px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
`;

export const SizeOptions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing60};
`;

export const SizeOption = styled.div`
  width: 52px;
  height: 40px;
  border-radius: ${({ theme }) => theme.borders.radius60};
  background: ${({ theme }) => theme.colors.shimmerBg};
`;

export const ShimmerLine = styled(Line)`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.spacing240};
`;

export const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing80};
  width: 100%;
  margin-top: auto;
`;

const ActionButton = styled.div`
  height: ${({ theme }) => theme.spacing.spacing240};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borders.buttonBorderRadius};
  background: ${({ theme }) => theme.colors.shimmerBg};
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.buttonLarge};
`;

export const WishlistButton = styled(ActionButton)`
  min-width: 206px;
`;

export const AddToBagButton = styled(ActionButton)`
  flex: 1;
`;
